import script from "./ProfileProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileProjects.vue?vue&type=script&setup=true&lang=js"

import "./ProfileProjects.vue?vue&type=style&index=0&id=d673a252&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d673a252"]])

export default __exports__